import * as types from './types';
import axios from '../../../common/config/axios';

export const getSettingList = (data) => (dispatch, getState) => 
{
    data.country_id = getState().currentUser.data.country_id;
    axios.get('mall_setting/list', {params: data})
    .then((res) =>
    {
        dispatch (
        {
            type: types.MALL_SETTING_LIST,
            payload: res.data
        })
    })
    .catch(err => 
    {
        
    });
};

export const updateStatus = (data) => (dispatch, getState) =>
{
    // console.log(data);
    data.country_id = getState().currentUser.data.country_id;
    axios.post('mall_setting/update_status', data)
    .then((res) =>
    {
      dispatch (
      {
        type: types.UPDATE_MALL_SETTING_STATUS,
        payload: res.data
    })
    })
    .catch(err => 
    {
      
    });
};

